module.exports = __webpack_public_path__ + "img/ekran10@2x.dd64916e.png";